import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, CircularProgress, List, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getServerUri } from "../modules/uriUtility";

const useClasses = makeStyles({
  title: {
    textAlign: "center",
    padding: "16px 24px 8px",
  },
  intro: {
    textAlign: "center",
    marginBottom: "12px",
  },
  list: {
    maxHeight: "200px",
    overflow: "auto",
    backgroundColor: "#2a2a2a",
    borderRadius: "4px",
    padding: 0,
  },
  listItem: {
    padding: "4px 12px",
  },
  itemText: {
    color: "#ccc",
    fontSize: "0.85rem",
    fontFamily: "monospace",
  },
  actions: {
    justifyContent: "center",
    padding: "16px",
  },
  progressRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    padding: "12px 0",
  },
});

export default function dialogConfirmRefresh(props) {
  const classes = useClasses();
  const [isRepairing, setIsRepairing] = useState(false);

  const handleRefresh = async () => {
    if (!props.versionID) {
      props.setIsOpen(false);
      return;
    }
    setIsRepairing(true);
    try {
      const response = await fetch(getServerUri("version/repairBrokenAssets"), {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          versionID: String(props.versionID),
        }),
      });
      const result = response.ok ? await response.json() : { unrepaired: 0 };
      if (props.onRepairDone) {
        await props.onRepairDone(props.versionID, result.unrepaired > 0 ? props.brokenAssets : null);
      }
    } catch (err) {
      console.error("Repair failed:", err);
    } finally {
      setIsRepairing(false);
      props.setIsOpen(false);
    }
  };

  const brokenAssets = props.brokenAssets || [];

  return (
    <Dialog open={props.isOpen} disableEscapeKeyDown fullWidth maxWidth="xs">
      <DialogTitle className={classes.title}>Missing assets detected</DialogTitle>
      <DialogContent>
        {isRepairing ? (
          <div className={classes.progressRow}>
            <CircularProgress size={22} />
            <Typography>Repairing version...</Typography>
          </div>
        ) : (
          <>
            <Typography className={classes.intro}>
              This version references {brokenAssets.length} missing asset{brokenAssets.length !== 1 ? "s" : ""}. Click refresh to replace them automatically.
            </Typography>
            {brokenAssets.length > 0 && (
              <List dense className={classes.list}>
                {brokenAssets.map((asset, idx) => {
                  const fileLabel = asset.file || asset.id;
                  const captionLabel = asset.componentCaption || "Unknown";
                  return (
                    <ListItem key={`broken:${asset.type}:${asset.id}:${idx}`} className={classes.listItem}>
                      <ListItemText
                        primary={`${asset.type}: ${captionLabel} – ${fileLabel}`}
                        primaryTypographyProps={{ className: classes.itemText }}
                      />
                    </ListItem>
                  );
                })}
              </List>
            )}
          </>
        )}
      </DialogContent>
      {!isRepairing && (
        <DialogActions className={classes.actions}>
          <Button color="primary" variant="contained" onClick={handleRefresh}>
            Refresh
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
